import type { ReactNode } from "react";
import { AlertTriangle, CheckCircle2, Info, OctagonAlert, type LucideIcon } from "lucide-react";
import type { Tone } from "../../lib/format.js";
import { cx } from "./cx.js";

const ICONS: Record<Tone, LucideIcon> = {
  neutral: Info,
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  danger: OctagonAlert,
  accent: Info,
};

export interface CalloutProps {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  icon?: LucideIcon;
}

export function Callout({ tone = "neutral", title, children, action, icon }: CalloutProps) {
  const Icon = icon ?? ICONS[tone];
  return (
    <div className={cx("callout", tone !== "neutral" && `callout--${tone}`)} role={tone === "danger" ? "alert" : "status"}>
      <Icon className="callout__icon" aria-hidden />
      <div className="callout__body">
        {title ? <div className="callout__title">{title}</div> : null}
        {children ? <div>{children}</div> : null}
      </div>
      {action}
    </div>
  );
}
